import { render, staticRenderFns } from "./product-description.vue?vue&type=template&id=618f6f7e&"
import script from "./product-description.vue?vue&type=script&lang=js&"
export * from "./product-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports